<template>
  <section id="section_checktoken">
    <Styles>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <div class="columns">
        <div class="column">
          <b-field label="Ingresa el Token">
            <b-input
              placeholder="Ingresa el token"
              type="text"
              name="token"
              v-model="token"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column text-right">
          <vs-button
            color="primary"
            @click="checkToken"
            icon="send"
            class="pl-5 pr-5"
            type="filled"
          >
            Verificar token
          </vs-button>
        </div>
      </div>
      <div class="columns" v-if="getPropView(result, 'access.entity')">
        <div class="column">
          <fieldset class="fieldset">
            <legend>Descripción Usuario:</legend>
            <div class="group-data">
              <div class="group-item">
                <label>Nombre:</label
                ><span>{{ getPropView(result, "access.entity.name") }}</span>
              </div>
              <div class="group-item">
                <label>Identificación:</label
                ><span>{{
                  getPropView(result, "access.entity.identification")
                }}</span>
              </div>
              <div class="group-item">
                <label>Email:</label
                ><span>{{
                  getEmailCompany(result, "access.entity.email")
                }}</span>
              </div>
              <div class="group-item">
                <label>Teléfono:</label
                ><span>{{
                  getPhoneCompany(result, "access.entity.email")
                }}</span>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="columns" v-if="getPropView(result, 'access.company')">
        <div class="column">
          <fieldset class="fieldset">
            <legend>Descripción Empresa:</legend>
            <div class="group-data">
              <div class="group-item">
                <label>Nombre:</label
                ><span>{{ getPropView(result, "access.company.name") }}</span>
              </div>
              <div class="group-item">
                <label>Identificación:</label
                ><span>{{
                  getPropView(result, "access.company.identification")
                }}</span>
              </div>
              <div class="group-item">
                <label>Email:</label
                ><span>{{
                  getEmailCompany(result, "access.company.email")
                }}</span>
              </div>
              <div class="group-item">
                <label>Teléfono:</label
                ><span>{{
                  getPhoneCompany(result, "access.company.email")
                }}</span>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="columns" v-if="getPropView(result, 'device')">
        <div class="column">
          <fieldset class="fieldset">
            <legend>Descripción Dispositivo:</legend>
            <div class="group-data">
              <div class="group-item">
                <label>Nombre:</label
                ><span>{{ getPropView(result, "device.title") }}</span>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </Styles>
  </section>
</template>

<script>
import { ROUTES } from "../../../global/api_routes";
import Styles from "./styles";
import { get as getProp } from "object-path";

export default {
  name: "CheckToken",
  components: { Styles },
  data: () => ({
    token: null,
    result: null,
    isLoading: false,
  }),
  mounted() {},
  methods: {
    getPropView(obj, path, defualtValue) {
      console.log(obj);
      return getProp(obj, path, defualtValue);
    },    
    getEmailCompany(obj, path) {
      try {
        const emailJson = JSON.parse(getProp(obj, path));
        if (Array.isArray(emailJson) && emailJson.length > 0) {
          return emailJson[0].email;
        }
      } catch (error) {}
      return "Indefinido";
    },
    getPhoneCompany(obj, path) {
      try {
        const emailJson = JSON.parse(getProp(obj, path));
        if (Array.isArray(emailJson) && emailJson.length > 0) {
          return emailJson[0].phone;
        }
      } catch (error) {}
      return "Indefinido";
    },
    checkToken() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.ACCESS.CHECK_TOKEN, {
          params: {
            token: this.token,
          },
        })
        .then(({ data }) => {
          console.log(data);
          this.result = data.info;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>